(ns hai.web-app.util.scroll
  "Utilities for scrolling behavior")

(defn scroll-into-view-if-hash-matches
  "Callback ref that scrolls the element into view if the URL hash matches its id.
   Use as: {:ref (scroll-into-view-if-hash-matches \"my-id\")}"
  [element-id]
  (fn [el]
    (when (and el (= (str "#" element-id) (.-hash js/location)))
      (.scrollIntoView el #js {:behavior "smooth"}))))
